import PropTypes from 'prop-types';
import Content from './contentItem';

/**
 * @memberof module:react/propTypes
 * @typedef {Object} Content
 * @prop {string} searchType Search type
 * @prop {module:react/propTypes~ContentItem[]} contentList List of content
 * @prop {number} pageNumber Current page number
 * @prop {number} totalPages Total number of pages
 * @prop {number} maxContent number of content per page
 * @prop {boolean} needUpdate True if the list needs updating
 * @prop {boolean} loading True if awaiting response from the server
 */
export default PropTypes.shape({
  searchType: PropTypes.string,
  contentList: PropTypes.arrayOf(Content),
  pageNumber: PropTypes.number,
  totalPages: PropTypes.number,
  maxContent: PropTypes.number,
  needUpdate: PropTypes.bool,
  loading: PropTypes.bool
});



// WEBPACK FOOTER //
// ./app/propTypes/content.js